import { render, staticRenderFns } from "./StepTracker.vue?vue&type=template&id=0b84a510&"
import script from "./StepTracker.vue?vue&type=script&lang=js&"
export * from "./StepTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports